import { h, Host } from "@stencil/core";
import { AppState } from "../../service/app-state";
export class ButtonToggleSearch {
    constructor() {
        this.open = false;
        this.changeListener = () => {
            this.open = AppState.search;
        };
    }
    componentDidLoad() {
        this.open = AppState.search;
        AppState.addEventListener(this.changeListener);
    }
    disconnectedCallback() {
        AppState.removeEventListener(this.changeListener);
    }
    onClick() {
        AppState.toggleSearch();
        this.open = AppState.search;
    }
    render() {
        return (h(Host, { key: '5283e20379f5b51affdd2e2f371f062c0dbf860b', role: "button", class: {
                'btn-icon': true,
                'active': this.open
            } }, h("svg", { key: '6e5d1ed7df1d8f551d36ab1c2b87d339e82c64a1', xmlns: "http://www.w3.org/2000/svg", width: "24", height: "25" }, h("use", { key: '899dd03e84907ee00a9fa2c2432c272d63c83f88', href: "#search" }))));
    }
    static get is() { return "uvex-button-toggle-search"; }
    static get states() {
        return {
            "open": {}
        };
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=button-toggle-search.js.map
